/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_SigninInputs */

const en_mk_nav_signin = /** @type {(inputs: Mk_Nav_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const id_mk_nav_signin = /** @type {(inputs: Mk_Nav_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Mk_Nav_SigninInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_signin = /** @type {((inputs?: Mk_Nav_SigninInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_SigninInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_signin(inputs)
	return en_mk_nav_signin(inputs)
});